import { useMutation } from "@tanstack/react-query";

export const useDepositWithBody = (onError?: (response: Response) => void) => {
  const mutation = useMutation<
    {
      requestId: number;
    },
    Error,
    Record<string, unknown>
  >({
    mutationKey: [onError],
    mutationFn: async (body) => {
      const response = await fetch(
        `${window.__APP_CONFIG.apiBaseUrl}/head/requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        if (onError) {
          onError(response);
        } else {
          // A rejection body carries the reason as {"error": "..."} — e.g. a
          // pre-RequestId screening rejection ("l2_payload failed to decrypt").
          // Surface it to the user; fall back to the status code when the body
          // isn't that shape (proxy errors, HTML error pages, ...).
          const reason = await response
            .json()
            .then((body) => (typeof body?.error === "string" ? body.error : null))
            .catch(() => null);
          throw new Error(
            reason ?? `Hydrozoa operation failed with status ${response.status}`,
          );
        }
      }

      return response.json();
    },
  });

  return mutation;
};
